module.exports = __webpack_public_path__ + "static/media/face-3.ce7a6b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/face-3.jpg
// module id = 540
// module chunks = 0